export const VENDOR_REVIEW_DATE = "September 25, 2026";
export const TRANSFER_UPDATE_DATE = "November 27, 2026";

export const SUBPROCESSOR_ROWS: string[][] = [
  [
    "Amazon Web Services (AWS)",
    "Application hosting, GPU inference, databases, storage, backups and infrastructure services",
    "EU (Spain, eu-south-2); US (us-east-1) for requests sent to api.us.condense.chat; global services have service-specific processing",
    "EU SCCs (AWS GDPR Data Processing Addendum)",
  ],
  [
    "Clerk",
    "Authentication, accounts, organizations and invitations",
    "United States",
    "EU-U.S. Data Privacy Framework; EU SCCs as fallback",
  ],
  [
    "Stripe",
    "Payments, subscriptions, credits, invoices and billing portal",
    "United States and other Stripe locations",
    "EU-U.S. Data Privacy Framework; EU SCCs as fallback",
  ],
  [
    "Google (Gmail SMTP)",
    "Transactional and subscribed product email delivery; recipient addresses and message content",
    "Any country where Google or its subprocessors operate, including the United States",
    "EU SCCs, or the EU-U.S. Data Privacy Framework where Google relies on it",
  ],
  [
    "Google (Gemini API)",
    "AI-assisted incident analysis of operational logs, alerts and diagnostics when enabled",
    "Any country where Google or its subprocessors operate, including the United States",
    "EU SCCs, or the EU-U.S. Data Privacy Framework where Google relies on it",
  ],
  [
    "Anthropic",
    "Condense-managed compression of conversation content when an Anthropic-backed strategy is enabled",
    "United States and other countries",
    "EU SCCs (Modules 2 and 3) with UK and Swiss addenda",
  ],
  [
    "PostHog",
    "Product analytics and account-registration events; consent-gated browser analytics and optional session replay",
    "EU (Germany), PostHog Cloud EU",
    "Not applicable (EU processing)",
  ],
  [
    "Slack",
    "Operational alerts, incident reports and aggregate business dashboards",
    "United States",
    "EU-U.S. Data Privacy Framework; EU SCCs in Slack's DPA",
  ],
  [
    "Linear",
    "Incident tickets containing logs and analysis when the integration is enabled",
    "United States",
    "EU SCCs with UK Addendum",
  ],
];

export const OPERATIONAL_VENDOR_ROWS: string[][] = [
  ["Tailscale", "Private networking and administrative access", "Operations"],
  [
    "GitHub",
    "Source repositories, CLI builds and release downloads",
    "Development and software delivery",
  ],
  [
    "Hugging Face",
    "Model and tokenizer downloads",
    "Model distribution; does not imply hosted inference",
  ],
  ["Google OAuth", "Operator sign-in", "Internal access"],
  ["Google Fonts", "Font delivery and browser request metadata", "Website"],
  ["Cal.com", "Contact details and meeting bookings", "Linked booking service"],
  [
    "Calendly",
    "Contact details and meeting bookings",
    "Linked booking service",
  ],
  [
    "Let's Encrypt / ISRG",
    "Certificate issuance",
    "Configured for private infrastructure; public production TLS uses AWS ACM",
  ],
  [
    "Cloudflare",
    "Bot checks used by the authentication provider",
    "Indirect dependency through Clerk; not a separate hosting provider",
  ],
];

export const PROVIDER_LOCATION_NOTICE =
  "Our application hosting is in AWS Europe (Spain). Requests you send to api.us.condense.chat are received and processed on AWS in the United States (us-east-1): conversation content is held in memory only and sent to our EU infrastructure for compression, while account, billing and administrative data stay in the EU. Requests to api.condense.chat are processed in the EU. Several providers above process personal data in the United States under the safeguards listed. Contact team@condense.chat for a copy of the safeguards for a specific provider.";

export const PROVIDER_CONTRACT_NOTICE =
  "Provider names identify services, not necessarily the contracting legal entities. Providers acting as subprocessors are subject to the data-protection obligations in our Data Processing Addendum. Applicable entities, processing locations and transfer safeguards depend on the service and agreement; an EU endpoint alone does not establish them.";

export const UPSTREAM_PROVIDER_NOTICE =
  "When you select an upstream LLM provider and supply your own credentials, your direct relationship with that provider governs its handling of the forwarded requests. This is separate from providers engaged by Condense to process data on your behalf, including Anthropic-backed compression when enabled and any provider accessed using Condense-managed credentials. A provider can serve both roles; the customer-selected upstream distinction does not exclude Condense-managed processing from our subprocessor obligations.";
